import { MapPoint } from '../types';

export const MONACO_MAP_POINT: MapPoint = { lat: 43.73841760000001, lng: 7.424615799999999 };
export const NICE_MAP_POINT: MapPoint = { lat: 43.6730333, lng: 7.1923217 };
export const DISTANCE_BETWEEN_MONAKO_AND_NICE_AIRPORT_KM = 20;
export const AVERAGE_COVERED_DISTANCE_IN_CITY_PER_DAY_KM = 5;
